/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdToastProps } from './type';

export const toastDefaultProps: TdToastProps = {
  direction: 'row',
  duration: 2000,
  overlayProps: {},
  placement: 'middle',
  preventScrollThrough: false,
  showOverlay: false,
};
